import * as d3 from 'd3'
import * as _ from 'lodash'

import State from '../State'

export function getNestedData(csv, nestFields, filters) {

  let parseTime = d3.timeParse("%d/%m/%Y")

  let filteredCsv = _.map(csv, d => d)

  // Range filters
  State.filters.numericRange.forEach(f => {
    filteredCsv = _.filter(filteredCsv, d => d[f.field] >= f.range[0] && d[f.field] <= f.range[1])
  })

  // Time filters
  // State.filters.dateRange.forEach(f => {
  //   filteredCsv = _.filter(filteredCsv, d => {
  //     let date = parseTime(d[f.field])
  //     // console.log(date, f.range[0], date >= f.range[0])
  //     return date >= f.range[0] && date <= f.range[1]
  //   })
  // })

  // Category filters
  State.filters.categoryMatch.forEach(f => {
    if(f.values.length === 0)
      return
    filteredCsv = _.filter(filteredCsv, d => _.includes(f.values, d[f.field]))
  })


  let activeNestFields = _.filter(nestFields, d => d.active)
  // console.log(activeNestFields)

  if(activeNestFields.length === 0)
    return []

  var nested = d3.nest()

  activeNestFields.forEach(f => {
    nested = nested.key(d => d[f.name])
  })

  nested = nested.rollup(d => d) // do this so that we can identify leaves
    .entries(filteredCsv)

  function processLeaves(groups) {
    groups.forEach(group => {
      if(group.value) {
        group.leaf = true
        group.values = group.value
        delete group.value
      } else {
        processLeaves(group.values)
        group.leaf = false
      }
    })
  }

  function addStats(groups, depth) {
    groups.forEach(group => {
      if(group.leaf === true) {
        // Leaf
        group.summary = {
          depth: depth,
          field: activeNestFields[depth].name,
          numNodes: 1,
          numItems: group.values.length,
          expenditure: {
            sum: _.sumBy(group.values, d => d['TotalExpenditure'])
          }
        }
      } else {
        addStats(group.values, depth + 1)
        group.summary = {
          depth: depth,
          field: activeNestFields[depth].name,
          numNodes: _.sumBy(group.values, d => d.summary.numNodes),
          numItems: _.sumBy(group.values, d => d.summary.numItems),
          expenditure: {
            sum: _.sumBy(group.values, d => d.summary.expenditure.sum)
          }
        }
      }
      group.sortKey = group.key
    })
  }

  function convertDates(groups, depth) {
    // D3 nest converts dates to strings, so we need to convert to date objects after nest
    groups.forEach(group => {
      if(group.leaf === false)
        convertDates(group.values, depth + 1)

      if(activeNestFields[depth].name === 'DateIncurred') {
        group.parsedDate = parseTime(group.key)
        group.sortKey = group.parsedDate
      }
    })
  }

  function addPathIdsForReact(groups, parentKey = '') {
    groups.forEach(group => {
      if(group.values) {
        let pathId = parentKey + '-' + group.key
        group.pathId = pathId
        addPathIdsForReact(group.values, pathId)
      }
    })
  }

  function sortGroups(groups) {
    groups.forEach(group => {
      if(group.leaf === true) {
        group.values = _.sortBy(group.values, d => -d.TotalExpenditure)
        return
      }

      if(State.sortByValue)
        group.values = _.sortBy(group.values, d => -d.summary.expenditure.sum)
      else
        group.values = _.sortBy(group.values, d => d.sortKey)

      sortGroups(group.values)
    })

    let ret = []
    if(State.sortByValue)
      ret = _.sortBy(groups, d => -d.summary.expenditure.sum)
    else
      ret = _.sortBy(groups, d => d.sortKey)

    return ret
  }

  processLeaves(nested)
  addStats(nested, 0)
  convertDates(nested, 0)
  addPathIdsForReact(nested)
  nested = sortGroups(nested)

  return nested
}



// WEBPACK FOOTER //
// ./src/DataProcessing/index.js